import type { StyledComponent } from '@emotion/styled';
import type { StackProps } from '@mui/material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { Property } from 'csstype';
import React from 'react';

type HelixStackProps = {
  spacing?: number;
  rowSpacing?: number;
  columnSpacing?: number;
  component?: React.ElementType;
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
  direction?: Property.FlexDirection;
  className?: string;
  wrap?: boolean;
  sx?: StackProps['sx'];
};

// The native MUI Stack component resets margins to 0. This is a known issue that doesn't yet have a solution. https://github.com/mui/material-ui/issues/33155
// To work around this I've created a simple component to support single dimension layouts.
const HelixStackRoot: React.FC<HelixStackProps> = ({ children, component, className, sx }) => {
  return (
    <Box component={component} className={className} sx={sx}>
      {children}
    </Box>
  );
};

const HelixStack: StyledComponent<HelixStackProps> = styled(HelixStackRoot)<HelixStackProps>((props) => {
  const { theme, alignItems, direction, wrap, rowSpacing, columnSpacing, spacing = 0, justifyContent } = props;
  return {
    alignItems,
    display: 'flex',
    flexDirection: direction ?? 'column',
    flexWrap: wrap ? 'wrap' : undefined,
    rowGap: theme.spacing(rowSpacing ?? spacing),
    columnGap: theme.spacing(columnSpacing ?? spacing),
    justifyContent,
  };
});

export { HelixStack as default, HelixStack };
export type { HelixStackProps };
